<template>
    <IndexBase @auth="onAuth($event)" action="SummaryReport" controller="Report"></IndexBase>

    <Card>
        <template #content>
            <DataTable ref="dt" responsiveLayout="scroll" class="p-datatable-sm" showGridlines filterDisplay="row" sortMode="multiple" removableSort
                       resizableColumns
                       columnResizeMode="fit"
                       :value="dataModel" 
                       :loading="!dataModel || loading"
                       :paginator="true"
                       :rows="10"
                       :lazy="true"
                       v-model:first="this.start"
                       @state-restore="onStateRestore($event)"
                       @page="onPage($event)"
                       @sort="onSort($event)"
                       @filter="onFilter($event)"
                       v-model:filters="filters"
                       :totalRecords="totalRecords"
                       dataKey="Id" 
                    >
                    <template #header>
                        <div class="p-card-title center mb-5">
                          {{$t('summary_report')}}
                            <Button  :label="$t('export')" icon="pi pi-print" class="p-button-help p-button-sm" v-if="dataModel" @click="onExport" style="float: right;"/>
                         </div>

                        <div class="p-inputtext-sm p-fluid filters-section">
                            <div class="grid">
                                <div class="col-12">
                                    <!-- Row 1: Report Generate Date (label left, inputs right) -->
                                    <div class="grid mb-2 filter-row">
                                        <div class="col-2 filter-label">
                                            <label>{{$t('generate_date_wo')}}</label>
                                        </div>
                                        <div class="col-10 filter-input">
                                            <div class="grid">
                                                <div class="col-6">
                                                    <DatePicker name="From_Date" v-model="From_Date" :placeholder="$t('from_date')"  
                                                        dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" />
                                                </div>
                                                <div class="col-6">
                                                    <DatePicker name="Request_Date" v-model="To_Date" :placeholder="$t('to_date')" 
                                                        dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Row 2: WO Number filter (label left, input + search right) -->
                                    <div class="grid mb-2 filter-row">
                                        <div class="col-2 filter-label">
                                            <label>{{$t('no_wo')}}</label>
                                        </div>
                                        <div class="col-9 filter-input">
                                            <CustomMultiSelect class="full-width p-inputtext-sm" name="listtransacton"
                                                v-model="listtransacton"
                                                :url="$API_URL + 'list/no_wo'"
                                                :params="{}"
                                                :minLength="0"
                                                :filter="true"
                                                :placeholder="$t('no_wo')"/>
                                        </div>
                                        <div class="col-1 flex align-items-center">
                                            <Button icon="pi pi-search" class="p-button-primary p-button-sm" @click="filterDataTable" />
                                        </div>
                                    </div>

                                    <!-- Row 3: View Data (label left, MultiSelect right) -->
                                    <div class="grid filter-row">
                                        <div class="col-2 filter-label">
                                            <label>{{$t('view_data')}}</label>
                                        </div>
                                        <div class="col-10 filter-input">
                                            <MultiSelect class="full-width p-inputtext-sm" v-model="selectedColumns"
                                                :options="columnOptions"
                                                optionLabel="text"
                                                optionValue="id"
                                                display="chip"
                                                :filter="true"
                                                :placeholder="$t('visible_columns')"
                                                @change="onColumnsChange" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    
                    <Column :exportable="false" :sortable="false" headerStyle="white-space:nowrap">
                        <template #header>
                            <Button :label="$t('clear')" icon="pi pi-filter-slash"
                            class="p-button-outlined p-button-primary p-button-sm" @click="clearFilter" :badge="filterBadge"
                            badgeClass="p-badge-danger" />
                        </template>
                        <template #body="slotProps">
                           <p class="center">{{ slotProps.index +=1 }}</p> 
                         </template>
                    </Column>
                
                    <Column v-if="showColumn('No_Wo')" field="No_Wo" :header="$t('no_wo')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('no_wo')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('WO_Type')" field="WO_Type" :header="$t('type')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('type')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('WO_Number_Main')" field="WO_Number_Main" :header="$t('Link_Main_Wo')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Link_Main_Wo')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('Company_Code')" field="Company_Code" :header="$t('company')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('company')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('No_SPO')" field="No_SPO" :header="$t('no_spo')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('no_spo')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('SPO_Date')" field="SPO_Date" :header="$t('spo_date')" dataType="date" :sortable="false">
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('spo_date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.SPO_Date)}}
                        </template>
                    </Column>

                    <Column v-if="showColumn('No_SPK')" field="No_SPK" :header="$t('no_spk')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('no_spk')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('Waktu_Penyelesaian')" field="Waktu_Penyelesaian" :header="$t('duration_day')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('duration_day')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('WBS_Allocation')" field="WBS_Allocation" :header="$t('WBS_Allocation')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('WBS_Allocation')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    
                    <Column v-if="showColumn('Work_Description')" field="Work_Description" :header="$t('Work_Description')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Work_Description')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('PIC')" field="PIC" :header="$t('pic')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('pic')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Contractor_Code')" field="Contractor_Code" :header="$t('code_contractor')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('code_contractor')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Currency_Code')" field="Currency_Code" :header="$t('Currency')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Currency')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Nilai_Kontrak')" field="Nilai_Kontrak" :header="$t('initial_contract_value')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('initial_contract_value')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                        <template #body="{ data }">
                            {{ data.Nilai_Kontrak != null 
                                ? this.$formatNumber(data.Nilai_Kontrak) 
                                : '' 
                            }}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Created_Date')" field="Created_Date" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Main Data</u></div>
                                <div>Create Date</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('create_Main_Data')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Created_Date)}}
                        </template>
                    </Column>

                    <!-- MC0-->
                    <Column v-if="showColumn('Created_Date_MC0')" field="Created_Date_MC0" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>MC-0</u></div>
                                <div>Create Date</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Created_Date_MC0')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Created_Date_MC0)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_MC0')" field="Rev_MC0"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>MC-0</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_MC0')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Approval_Date_MC0')" field="Approval_Date_MC0" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>MC-0</u></div>
                                <div>Approval Date</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Approval_Date_MC0')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Approval_Date_MC0)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Verification_Date_MC0')" field="Verification_Date_MC0" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>MC-0</u></div>
                                <div>Verification Date</div>
                            </div>
                        </template>
                        
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Verification_Date_MC0')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Verification_Date_MC0)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Process_Add_MC0')" field="Process_Add_MC0" :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Add MC-0</u></div>
                                <div>Proceed</div>
                            </div>
                        </template>
                        
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Process_Add_MC0')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Created_Date_Add_MC0')" field="Created_Date_Add_MC0"  dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Add MC-0</u></div>
                                <div>Created Date</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Created_Date_Add_MC0')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Created_Date_Add_MC0)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_Add_MC0')" field="Rev_Add_MC0" :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Add MC-0</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_Add_MC0')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Approval_Date_Add_MC0')" field="Approval_Date_Add_MC0" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Add MC-0</u></div>
                                <div>Approval Date</div>
                            </div>
                        </template>
                        
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Approval_Date_Add_MC0')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Approval_Date_Add_MC0)}}
                        </template>
                    </Column>

                    <Column v-if="showColumn('Final_Contract_Amount_ADD_MC0')" field="Final_Contract_Amount_ADD_MC0" :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Add MC-0</u></div>
                                <div>Latest Contract Value</div>
                            </div>
                        </template>
                        
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Final_Contract_Amount_ADD_MC0')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                        <template #body="{ data }">
                            {{ data.Final_Contract_Amount_ADD_MC0 != null 
                                ? this.$formatNumber(data.Final_Contract_Amount_ADD_MC0) 
                                : '' 
                            }}
                        </template>
                    </Column>

                    <!-- BAIK -->
                    <Column v-if="showColumn('Type_BAIK')" field="Type_BAIK" :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BA-IK</u></div>
                                <div>Type</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Type_BAIK')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Created_Date_BAIK')" field="Created_Date_BAIK" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BA-IK</u></div>
                                <div>Created Date</div>
                            </div>
                        </template>
                       
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Created_Date_BAIK')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Created_Date_BAIK)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_BAIK')" field="Rev_BAIK" :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BA-IK</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_BAIK')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Approval_Date_BAIK')" field="Approval_Date_BAIK" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BA-IK</u></div>
                                <div>Approval Date</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Approval_Date_BAIK')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Approval_Date_BAIK)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Start_Date_BAIK')" field="Start_Date_BAIK" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BA-IK</u></div>
                                <div>Start Date</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Start_Date_BAIK')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Start_Date_BAIK)}}
                        </template>
                    </Column>
                        <!-- KOM -->
                    <Column v-if="showColumn('Created_Date_KOM')" field="Created_Date_KOM" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>KOM</u></div>
                                <div>Created Date</div>
                            </div>
                        </template>
                        
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Created_Date_KOM')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Created_Date_KOM)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_KOM')" field="Rev_KOM" :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>KOM</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_KOM')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Submit_Date_KOM')" field="Submit_Date_KOM" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>KOM</u></div>
                                <div>Submit Date</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Submit_Date_KOM')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Submit_Date_KOM)}}
                        </template>
                    </Column>

                    <!-- MC BETWEEN-->
                    <Column v-if="showColumn('Current_MC_BETWEEN')" field="Current_MC_BETWEEN"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>MC-Between</u></div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Current_MC_BETWEEN')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Created_Date_MC_BETWEEN')" field="Created_Date_MC_BETWEEN" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>MC-Between</u></div>
                                <div>Created Date</div>
                            </div>
                        </template>

                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Created_Date_MC_BETWEEN')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Created_Date_MC_BETWEEN)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_MC_BETWEEN')" field="Rev_MC_BETWEEN"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>MC-Between</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_MC_BETWEEN')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Approval_Date_MC_BETWEEN')" field="Approval_Date_MC_BETWEEN" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>MC-Between</u></div>
                                <div>Approval Date</div>
                            </div>
                        </template>
                        
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Approval_Date_MC_BETWEEN')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Approval_Date_MC_BETWEEN)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Verification_Date_MC_BETWEEN')" field="Verification_Date_MC_BETWEEN" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>MC-Between</u></div>
                                <div>Verification Date</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Verification_Date_MC_BETWEEN')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Verification_Date_MC_BETWEEN)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Process_ADD_MC_BETWEEN')" field="Process_ADD_MC_BETWEEN" :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>ADD MC-Between</u></div>
                                <div>Proceed</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Process_ADD_MC_BETWEEN')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Created_Date_ADD_MC_BETWEEN')" field="Created_Date_ADD_MC_BETWEEN" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>ADD MC-Between</u></div>
                                <div>Created Date</div>
                            </div>
                        </template>
                        
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Created_Date_ADD_MC_BETWEEN')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Created_Date_ADD_MC_BETWEEN)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_ADD_MC_BETWEEN')" field="Rev_ADD_MC_BETWEEN" :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>ADD MC-Between</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_ADD_MC_BETWEEN')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Approval_Date_ADD_MC_BETWEEN')" field="Approval_Date_ADD_MC_BETWEEN" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>ADD MC-Between</u></div>
                                <div>Approval Date</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Approval_Date_ADD_MC_BETWEEN')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Approval_Date_ADD_MC_BETWEEN)}}
                        </template>
                    </Column>

                    <Column v-if="showColumn('Final_Contract_Amount_ADD_MC_BETWEEN')" field="Final_Contract_Amount_ADD_MC_BETWEEN" :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>ADD MC-Between</u></div>
                                <div>Latest Contract Value</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Final_Contract_Amount_ADD_MC_BETWEEN')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                        <template #body="{ data }">
                            {{ data.Final_Contract_Amount_ADD_MC_BETWEEN != null 
                                ? this.$formatNumber(data.Final_Contract_Amount_ADD_MC_BETWEEN) 
                                : '' 
                            }}
                        </template>
                    </Column>

                    <!-- PROGRESS TERMIN -->
                    <Column v-if="showColumn('Count_Progress_Termin')" field="Count_Progress_Termin" :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Progress Report Termin</u></div>
                                <div>Number</div>
                            </div>
                        </template>
                        
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Count_Progress_Termin')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Created_Date_Progress_Termin')" field="Created_Date_Progress_Termin"  dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Progress Report Termin</u></div>
                                <div>Created Date</div>
                            </div>
                        </template>

                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Created_Date_Progress_Termin')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Created_Date_Progress_Termin)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Progress_To_Charge_Progress_Termin')" field="Progress_To_Charge_Progress_Termin" :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Progress Report Termin</u></div>
                                <div>Latest Progress(%)</div>
                            </div>
                        </template>
                        
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Progress_To_Charge_Progress_Termin')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Approval_Date_Progress_Termin')" field="Approval_Date_Progress_Termin"  dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Progress Report Termin</u></div>
                                <div>Approval Date</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Approval_Date_Progress_Termin')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Approval_Date_Progress_Termin)}}
                        </template>
                    </Column>

                    <!-- BAST TERMIN -->
                    <Column v-if="showColumn('Count_BAST_Termin')" field="Count_BAST_Termin"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAST Termin</u></div>
                                <div>Number</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Count_BAST_Termin')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Created_Date_BAST_Termin')" field="Created_Date_BAST_Termin"  dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAST Termin</u></div>
                                <div>Created Date</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Created_Date_BAST_Termin')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Created_Date_BAST_Termin)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Progress_To_Charge_BAST_Termin')" field="Progress_To_Charge_BAST_Termin"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAST Termin</u></div>
                                <div>Lastest Progress(%)</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Progress_To_Charge_BAST_Termin')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Approval_Date_BAST_Termin')" field="Approval_Date_BAST_Termin" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAST Termin</u></div>
                                <div>Approval Date</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Approval_Date_BAST_Termin')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Approval_Date_BAST_Termin)}}
                        </template>
                    </Column>

                    <!-- MC100-->
                    <Column v-if="showColumn('Created_Date_MC100')" field="Created_Date_MC100" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>MC-100</u></div>
                                <div>Created Date</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Created_Date_MC100')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Created_Date_MC100)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_MC100')" field="Rev_MC100" :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>MC-100</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_MC100')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Approval_Date_MC100')" field="Approval_Date_MC100" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>MC-100</u></div>
                                <div>Approval Date</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Approval_Date_MC100')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Approval_Date_MC100)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Verification_Date_MC100')" field="Verification_Date_MC100" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>MC-100</u></div>
                                <div>Verification Date</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Verification_Date_MC100')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Verification_Date_MC100)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Process_Add_MC100')" field="Process_Add_MC100" :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Add MC-100</u></div>
                                <div>Proceed</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Process_Add_MC100')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Created_Date_Add_MC100')" field="Created_Date_Add_MC100" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Add MC-100</u></div>
                                <div>Created Date</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Created_Date_Add_MC100')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Created_Date_Add_MC100)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_Add_MC100')" field="Rev_Add_MC100" :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Add MC-100</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_Add_MC100')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Approval_Date_Add_MC100')" field="Approval_Date_Add_MC100" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Add MC-100</u></div>
                                <div>Approval Date</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Approval_Date_Add_MC100')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Approval_Date_Add_MC100)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Percentage_Type_MC100')" field="Percentage_Type_MC100" :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Add MC-100</u></div>
                                <div>Deviation Type</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Percentage_Type_MC100')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Deviation_ADD_MC100')" field="Deviation_ADD_MC100" :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Add MC-100</u></div>
                                <div>Deviation</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Deviation_ADD_MC100')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Final_Contract_Amount_ADD_MC100')" field="Final_Contract_Amount_ADD_MC100" :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Add MC-100</u></div>
                                <div>Final Contract Value</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Final_Contract_Amount_ADD_MC100')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                        <template #body="{ data }">
                            {{ data.Final_Contract_Amount_ADD_MC100 != null 
                                ? this.$formatNumber(data.Final_Contract_Amount_ADD_MC100) 
                                : '' 
                            }}
                        </template>
                    </Column>

                        <!-- KOM QC-->
                    <Column v-if="showColumn('Created_Date_KOM_QC')" field="Created_Date_KOM_QC" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>KOM QC</u></div>
                                <div>Created Date</div>
                            </div>
                        </template>
                        
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Created_Date_KOM_QC')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Created_Date_KOM_QC)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_KOM_QC')" field="Rev_KOM_QC"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>KOM QC</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_KOM_QC')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Submit_Date_KOM_QC')" field="Submit_Date_KOM_QC" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>KOM QC</u></div>
                                <div>Submit Date</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Submit_Date_KOM_QC')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Submit_Date_KOM_QC)}}
                        </template>
                    </Column>

                    <!-- QC FINAL -->
                    <Column v-if="showColumn('Created_Date_QC')" field="Created_Date_QC" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>QC Final</u></div>
                                <div>Created Date</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Created_Date_QC')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Created_Date_QC)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_QC')" field="Rev_QC" :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>QC Final</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_QC')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Approval_Date_QC')" field="Approval_Date_QC" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>QC Final</u></div>
                                <div>Approval Date</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Approval_Date_QC')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Approval_Date_QC)}}
                        </template>
                    </Column>

                    
                    <!-- DELAY -->
                    <Column v-if="showColumn('Created_Date_Delay')" field="Created_Date_Delay" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BA Delay</u></div>
                                <div>Created Date</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Created_Date_Delay')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Created_Date_Delay)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_Delay')" field="Rev_Delay" :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BA Delay</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_Delay')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Approval_Date_Delay')" field="Approval_Date_Delay"  dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BA Delay</u></div>
                                <div>Approval Date</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Approval_Date_Delay')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Approval_Date_Delay)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Jumlah_hari_Keterlambatan')" field="Jumlah_hari_Keterlambatan" :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BA Delay</u></div>
                                <div>Number of Delay Days</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Jumlah_hari_Keterlambatan')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                     <!-- PENALTY -->
                    <Column v-if="showColumn('Created_Date_Penalty')" field="Created_Date_Penalty" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Penalty</u></div>
                                <div>Created Date</div>
                            </div>
                        </template>
                        
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Created_Date_Penalty')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Created_Date_Penalty)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_Penalty')" field="Rev_Penalty" :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Penalty</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_Penalty')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Approval_Date_Penalty')" field="Approval_Date_Penalty" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Penalty</u></div>
                                <div>Approval Date</div>
                            </div>
                        </template> 
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Approval_Date_Penalty')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Approval_Date_Penalty)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Penalty_Days')" field="Penalty_Days"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Penalty</u></div>
                                <div>Number of Penalty Days</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Penalty_Days')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Total_Penalty_Charged')" field="Total_Penalty_Charged"  :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Penalty</u></div>
                                <div>Penalty Value</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Total_Penalty_Charged')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                        <template #body="{ data }">
                            {{ data.Total_Penalty_Charged != null 
                                ? this.$formatNumber(data.Total_Penalty_Charged) 
                                : '' 
                            }}
                        </template>
                    </Column>


                    <!-- PROGRESS FINAL -->
                    <Column v-if="showColumn('Created_Date_Progress_Final')" field="Created_Date_Progress_Final" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Progress Report Final</u></div>
                                <div>Created Date</div>
                            </div>
                        </template>
                        
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Created_Date_Progress_Final')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Created_Date_Progress_Final)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_Progress_Final')" field="Rev_Progress_Final" :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Progress Report Final</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_Progress_Final')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Approval_Date_Progress_Final')" field="Approval_Date_Progress_Final" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>Progress Report Final</u></div>
                                <div>Approval Date</div>
                            </div>
                        </template>
                        
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Approval_Date_Progress_Final')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Approval_Date_Progress_Final)}}
                        </template>
                    </Column>

                    <!-- BAST FINAL -->
                    <Column v-if="showColumn('Created_Date_BA_Final')" field="Created_Date_BA_Final" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAST Final</u></div>
                                <div>Created Date</div>
                            </div>
                        </template>

                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Created_Date_BA_Final')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Created_Date_BA_Final)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_BA_Final')" field="Rev_BA_Final" :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAST Final</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_BA_Final')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Approval_Date_BA_Final')" field="Approval_Date_BA_Final" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAST Final</u></div>
                                <div>Approval Date</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Approval_Date_BA_Final')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Approval_Date_BA_Final)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Act_Date_BA_Final')" field="Act_Date_BA_Final" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAST Final</u></div>
                                <div>Actual Finish Date</div>
                            </div>
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Act_Date_BA_Final')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Act_Date_BA_Final)}}
                        </template>
                    </Column>

                    <!-- BAST RETENSI -->
                    <Column v-if="showColumn('Created_Date_BA_Retensi')" field="Created_Date_BA_Retensi" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAST Retensi</u></div>
                                <div>Created Date</div>
                            </div>
                        </template>
                        
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Created_Date_BA_Retensi')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Created_Date_BA_Retensi)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Rev_BA_Retensi')" field="Rev_BA_Retensi" :sortable="false" :filter="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAST Retensi</u></div>
                                <div>Revision</div>
                            </div>
                        </template>
                        
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Rev_BA_Retensi')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    <Column v-if="showColumn('Approval_Date_BA_Retensi')" field="Approval_Date_BA_Retensi"  dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAST Retensi</u></div>
                                <div>Approval Date</div>
                            </div>
                        </template>
                        
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Approval_Date_BA_Retensi')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Approval_Date_BA_Retensi)}}
                        </template>
                    </Column>
                    <Column v-if="showColumn('Act_Date_BA_Retensi')" field="Act_Date_BA_Retensi" dataType="date" :sortable="false">
                        <template #header>
                            <div style="text-align:center;">
                                <div style="font-weight:bold;"><u>BAST Retensi</u></div>
                                <div>Actual Retention Date</div>
                            </div>
                        </template>
                       
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Act_Date_BA_Retensi')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Act_Date_BA_Retensi)}}
                        </template>
                    </Column>

            </DataTable>
        </template>
    </Card>

   
</template>

<script>
    function getDefaultDates() {
        let fromDate = new Date();
        fromDate.setDate(fromDate.getDate() - 30);
        fromDate.setHours(0, 0, 0, 0);

        let toDate = new Date();
        toDate.setHours(23, 59, 59, 999);

        return { fromDate, toDate };
    }

    export default {
        name: "SummaryReport",
        components: {
        },
        data() {
            const { fromDate, toDate } = getDefaultDates();
            return {
                dataModel: null,
                loading: true,
                totalRecords: 0,
                start: 0,
                stateKey: 'pas-state-summaryreport-' + this.$store.getters.getUsername,
                role: this.$store.getters.getRole,
                isAdmin: this.$store.getters.getIsAdmin,
                isUser: this.$store.getters.getIsUser,
                isTransporter: this.$store.getters.getIsTransporter,
                isDriver: this.$store.getters.getIsDriver,
                sorts: null,
                lazyParams: {},
                filters: null,
                stateFilters: null,
                editorPath: "/ReleaseMatrix/Editor",
                dataUrl: "Report/listsummaryreport",
                exportUrl : "report/exportsummaryreport",
                canCreate: false,
                canEdit: false,
                canDelete: false,
                canView: false,
                changeval : null,
                From_Date : fromDate,
                To_Date : toDate,
                listtransacton: [],
                header: null,
                // column visibility control
                columnOptions: [],
                // list the fields you want visible by default (when user has no saved choice)
                defaultVisibleColumns: ['No_Wo','WO_Type', 'WO_Number_Main', 'Company_Code', 'No_SPO', 'SPO_Date','No_SPK', 'Waktu_Penyelesaian', 'WBS_Allocation', 'Work_Description', 
                                        'PIC', 'Contractor_Code', 'Currency_Code', 'Nilai_Kontrak', 'Created_Date', 
                                        'Verification_Date_MC0','Process_Add_MC0','Final_Contract_Amount_ADD_MC0','Type_BAIK','Start_Date_BAIK','Current_MC_BETWEEN','Verification_Date_MC_BETWEEN','Process_ADD_MC_BETWEEN',
                                        'Final_Contract_Amount_ADD_MC_BETWEEN','Count_BAST_Termin','Progress_To_Charge_BAST_Termin','Approval_Date_BAST_Termin','Verification_Date_MC100','Process_Add_MC100','Percentage_Type_MC100','Deviation_ADD_MC100',
                                        'Final_Contract_Amount_ADD_MC100','Approval_Date_QC','Jumlah_hari_Keterlambatan','Penalty_Days','Total_Penalty_Charged','Approval_Date_BA_Final','Approval_Date_BA_Retensi'],
                selectedColumns: [],
                // retry mechanism to wait for DataTable columns to be available
                _columnOptionsRetries: 0,
            }
        },
        methods: {
            onColumnsChange(val){
                // Prevent empty selection: if user unticks all, restore all columns and warn
                if(!this.selectedColumns || this.selectedColumns.length === 0){
                    // restore to all available columns
                    this.selectedColumns = this.columnOptions.map(o=>o.id);
                    if(this.$toast) this.$toast.add({ severity: 'warn', summary: 'Columns', detail: 'At least one column must be visible. Restored all columns.', life: 3000 });
                }
            },
            filterDataTable(){
                this.loadLazyData();
            },
            onChnageIsDeleted(event){
                this.changeval = event;
            },
            onAuth(event) {
                this.canCreate = event.canCreate;
                this.canEdit = event.canEdit;
                this.canDelete = event.canDelete;
                this.canView = event.canView;
            },
            onPage(event) {
                this.start = event.first;
                this.loadLazyData();
            },
            onSort(event) {
                this.sorts = event.multiSortMeta;
                this.loadLazyData();
            },
            onFilter() {
                this.loadLazyData();
            },
            onSelect(event){
                this.selectedRow = event.data;
            },
            onRowExpand(event){
                this.expandedRows = [];
                this.expandedRows.push(event.data);
            },
            editor(mode, id) {
                this.$router.push({ path: this.editorPath, query: { mode: mode, id: id } });
            },
            filter(mode) {
                this.$router.push({ path: this.filterPath, query: { mode: mode} });
            },
            sidebarMessage(event){
                this.$toast.add(event);
            },
            loadLazyData() {
                this.loading = true;
                this.selectedRow = null;
                const { fromDate, toDate } = getDefaultDates();
                if (!this.From_Date) this.From_Date = fromDate;
                if (!this.To_Date) this.To_Date = toDate;
            
                this.lazyParams = {
                    start: this.start,
                    sorts: this.dataSort,
                    filters: this.dataFilter,
                    from_date : this.From_Date,
                    to_date : this.To_Date,
                    listtransacton: this.listtransacton,
                    selectedColumns: this.selectedColumns || []
                };
            
                var self = this;
                this.$axios.post(this.$API_URL + this.dataUrl, this.lazyParams)
                    .then((response) => {
                        if (response.data.success) {
                            this.dataModel = response.data.data;
                            // capture header if API returns it in different shapes
                            this.header = response.data.header || (response.data.data && response.data.data.header) || this.header;
                            this.totalRecords = response.data.totalRecords;
                        }
                        else {
                            self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                        }
                        //this.$emit('unblock-ui');
                        this.loading = false;
                    })
                    .catch(function (err) {
                        self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        //this.$emit('unblock-ui');
                        self.loading = false;
                    });
            },
            setFilters() {
                this.filters = {};
                var exportable = this.$refs.dt.columns.filter(c => c.props.field);
                for (var i = 0; i < exportable.length; i++) {
                    var filterValue = null;
                    if(this.stateFilters){
                        var field = this.stateFilters[exportable[i].props.field];
                        if(field) filterValue = field.value;
                    }
                    this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
                }
            },
            // build columnOptions from DataTable columns and restore saved selection
            setColumnOptions(){
                try{
                    const cols = (this.$refs.dt && this.$refs.dt.columns) ? this.$refs.dt.columns.filter(c => c.props.field) : [];
                    // If columns are not yet available, retry a few times (DataTable may render after mounted)
                    if((!cols || cols.length===0) && this._columnOptionsRetries < 6){
                        this._columnOptionsRetries++;
                        setTimeout(() => { try{ this.setColumnOptions(); }catch(e){} }, 50);
                        return;
                    }
                    this.columnOptions = cols.map(c => {
                        let header = c.props.header;
                        let text = '';
                        if (header && typeof header === 'string') {
                            text = header;
                        } else {
                            try {
                                const translated = this.$t && this.$t(c.props.field);
                                text = (translated && translated !== c.props.field) ? translated : c.props.field;
                            } catch (e) {
                                text = c.props.field;
                            }
                        }
                        return { id: c.props.field, text };
                    });
                    // apply configured defaults (do NOT persist selection in localStorage)
                    const availableIds = this.columnOptions.map(o=>o.id);
                    const initial = (this.defaultVisibleColumns || []).filter(d => availableIds.includes(d));
                    this.selectedColumns = initial.length ? initial : availableIds;
                }catch(e){
                    // fallback: show all
                    this.columnOptions = [];
                    this.selectedColumns = [];
                }
            },
            showColumn(field){
                if(!this.selectedColumns || this.selectedColumns.length===0) return true;
                return this.selectedColumns.includes(field);
            },
            onStateRestore(event) {
                this.start = event.first;
                this.stateFilters = event.filters;
                this.sorts = event.multiSortMeta;
            },
            editOrder(){
                this.$router.push({ path: this.editorPath, query: { mode: this.$FORM_MODE_EDIT, id: this.selectedRow[0].Id } });
            },
             onModalClose(){
                this.loadLazyData();
            },
            clearFilter(){
                this.filters = {};
                var exportable = this.$refs.dt.columns.filter(c => c.props.field);
                this.changeval = null;
                
                const { fromDate, toDate } = getDefaultDates();
                this.From_Date = fromDate;
                this.To_Date = toDate;
                this.listtransacton = [];

                for (var i = 0; i < exportable.length; i++) {
                    var fieldName = exportable[i].props.field;
                    var filterValue = "";
                    if(fieldName.includes("Date") || fieldName.includes("Start_Work") || fieldName.includes("Finish_Work")){
                        filterValue = null;
                    }
                    this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
                }
                // reset selected columns to defaults (or all available if defaults not applicable)
                try{
                    const availableIds = exportable.map(c => c.props.field);
                    const defaults = (this.defaultVisibleColumns || []).filter(d => availableIds.includes(d));
                    this.selectedColumns = defaults.length ? defaults : availableIds;
                }catch(e){}

                this.loadLazyData();
            },
            onExport(){
                this.loading = true;
                this.selectedRow = null;
                const { fromDate, toDate } = getDefaultDates();
                if (!this.From_Date) this.From_Date = fromDate;
                if (!this.To_Date) this.To_Date = toDate;

                this.lazyParams = {
                    start: this.start,
                    sorts: this.dataSort,
                    filters: this.dataFilter,
                    from_date : this.From_Date,
                    to_date : this.To_Date,
                    listtransacton: this.listtransacton,
                    selectedColumns: this.selectedColumns || []
                };

                var self = this;

                this.$axios.post(this.$API_URL + this.exportUrl, this.lazyParams, {
                    responseType: 'blob',
                    timeout: this.$AXIOS_TIMEOUT_LONG
                    })
                    .then((response) => {
                        var contentDisposition = response.headers["content-disposition"];
                        var matchName = contentDisposition.match(/filename\s*=\s*"?(.+)"?/);
                        var filename = matchName[1].split(';')[0];
                        
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();
                        
                    })
                    .catch(function (err) {
                        self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 60000});
                    })
                    .finally(() => {
                        self.loading = false;
                    });
            }
            ,
            statusProgressStyle(data){
                // prefer per-row indicator in dataModel
                const rowIndicator = data && (data.Indicator_Status_Progress || data.indicator_status_progress || data.IndicatorStatusProgress);
                if (rowIndicator) {
                    return 'background-color: #ffc0cb; color: #000; padding:2px 6px; border-radius:4px; display:inline-block;';
                }
                return '';
            }
        },
        mounted() {
            this.$emit('unblock-ui');
            this.setFilters();
            this.$nextTick(() => {
                try{ this.setColumnOptions(); }catch(e){}
                // Inline fallback to ensure header spacing/styles show regardless of external CSS cascade
                try{
                    const headerEl = document.querySelector('.p-inputtext-sm.p-fluid');
                    if(headerEl){
                        headerEl.style.paddingBottom = '1rem';
                        headerEl.style.marginBottom = '1rem';
                        headerEl.style.borderBottom = '1px solid #eef2f5';
                    }
                }catch(e){}
            });
            this.loadLazyData();
            this.$showToast();
        },
        computed: {
            dataFilter() {
                var h = [];
                if (this.filters) {
                    for (const [key, value] of Object.entries(this.filters)) {
                        h.push({
                            field: key ? key : null,
                            value: value.value,
                            matchMode: value.matchMode
                        });
                    }
                }
                return h;
            },
            dataSort() {
                var h = [];
                if (this.sorts) {
                    for (var x = 0; x < this.sorts.length; x++) {
                        h.push({
                            field: this.sorts[x].field,
                            order: this.sorts[x].order == 1 ? "ASC" : "DESC"
                        });
                    }
                }
                return h;
            },
            filterBadge(){
                var badgeNumber = 0;

                if(this.From_Date!=null) badgeNumber+=1;
                if(this.To_Date!=null) badgeNumber+=1;

                this.dataFilter.filter(function(item) {                    
                    if(item.value){
                        badgeNumber++;
                    }
                });

                return badgeNumber;
            }
        },
    }
</script>

<style scoped>
/* keep minimal overrides if needed */
    .p-card .p-card-content{
        margin:0!important;
        padding: 0 !important;
    }
    .center{
        text-align: center;
    }
    /* make header title centered */
    .p-card-title.center {
        text-align: center;
        width: 100%;
    }
    /* align labels on left and inputs on right */
    .filters-section .filter-row {
        align-items: center;
    }
    .filters-section .filter-label {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-left: 0.75rem;
    }
    .filters-section .filter-input {
        display: flex;
        align-items: center;
    }
    .filters-section .filter-row .p-button {
        margin-left: 0.25rem;
    }
    /* ensure filter section uses full available width */
    .filters-section {
        width: 100%;
        max-width: none;
    }
    /* ensure components with full-width class actually expand */
    .filters-section .full-width {
        width: 100% !important;
    }
    /* ensure header-defined widths apply to body when resizing */
    .p-datatable .p-datatable-table {
        table-layout: fixed;
    }
    .p-datatable .p-datatable-thead th {
        white-space: normal;
    }
    .p-datatable .p-datatable-tbody td {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>